const flags = {
  revealOverlay: true,
};

export function isFeatureOn(key) {
  return Boolean(flags[key]);
}

export function setFeatureFlag(key, value) {
  flags[key] = Boolean(value);
}
